<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VSelectJob
      label="Добавить работы"
      name="jobs"
      isSingle
      :items="projectPTOJobList"
      :handler-search="GETProjectPTOJobList"
      class="form__input--col-2"
      @change='substitutionPlan'
      required
    >
      <Validation for="required">Поле обязательно</Validation>
    </VSelectJob>

    <VInput
      label="План, объем"
      name="plan_volume"
    />

    <VSelect
      label="Ед. изм."
      name="measure_unit"
      :items="measureUnitList"
      :handler-search="GETMeasureUnitList"
      search
    />

    <VInput
      label="План, руб."
      name="plan"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      label="Подписано, объем"
      name="sign_volume"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      label="Трудозатраты"
      name="labor_costs"
      pattern="^\d{0,2}(?:[.]\d{0,2})?$"
      @input='calculateFot'
    >
      <Validation for="pattern">Формат ввода: "01.01"</Validation>
    </VInput>

    <AppInputDate
      title="Дата начала"
      name="start_date"
      type="single"
      :value="!isEdit ? currentDate : modelFormData.start_date"
      @changed='changeStartDate'
    />

    <AppInputDate
      title="Дата окончания"
      name="finish_date"
      type="single"
      :value="!isEdit ? currentDate : modelFormData.finish_date"
    />

    <VInput
      label="Подписано, руб. (в ценах 2001)"
      name="sign_2001"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      label="№ КС-2"
      name="number_ks"
    />

    <VInput
      label="Подписано, руб. (в тек. ценах без НДС)"
      name="sign_without_nds"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      label="№ сч-ф"
      name="account_number"
    />

    <VInput
      label="Подписано, руб. (в тек. ценах с НДС)"
      name="sign_with_nds"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      label="ФОТ"
      name="fot"
      disabled
    />

    <VCheckbox
      title="Собственное производство"
      name="is_own_production"
      class="form__checkbox-wrap"
      type="switch"
    />

    <VCheckbox
      title="Доплата ФОТ"
      name="is_surcharge_fot"
      class="form__checkbox-wrap"
      type="switch"
    />
  </FormPto>
</template>

<script>
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'
import AppInputDate from '@/components/page/input/AppInputDate'
import VSelectJob from '@/components/page/Form/VSelectJob.vue'
import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { currentDate, formatDateForServer } from '@/utils/utils'
import { mixinPtoProjectPTOJobSelect } from '@/mixins/module/pto/mixinPtoProjectPTOJobSelect'
import { mapActions, mapState } from 'vuex'
import { prepareFormDataJob } from '@/utils/form/pto/prepareFormDataJob'
import { HHMM } from '@/utils/form/regularExpression'

export default {
  name: 'FormPtoProjectWorkSign',
  components: {
    FormPto,
    PTOProjectTitle,
    // eslint-disable-next-line vue/no-unused-components
    Validation,
    VCheckbox,
    VInput,
    AppInputDate,
    VSelectJob,
    VSelect
  },
  data () {
    return {
      regularHHMM: HHMM
    }
  },
  beforeMount () {
    if (this.formData.measure_unit_id) {
      this.formData.measure_unit = this.findItemHandbookById('measureUnitList', this.formData.measure_unit_id)
    }

    if (this.formData.job_id) {
      const job = this.findItemHandbookById('projectPTOJobs', this.formData.job_id)
      const transformJob = prepareFormDataJob(job)
      this.formData.jobs = [transformJob]
    }
  },
  methods: {
    ...mapActions('handbook/pto', {
      GETMeasureUnitList: 'GETMeasureUnitList',
      GETCostPersonHourList: 'GETCostPersonHourList'
    }),
    // update formData value after set/clear Job
    setItemAfterUpdateJob ({ plan = 0, planVolume = '', measureUnit = '' }) {
      this.formData.plan = plan
      this.formData.plan_volume = planVolume
      this.formData.measure_unit = measureUnit
    },
    clearItemAfterUpdateJob () {
      this.setItemAfterUpdateJob({})
    },
    findItemHandbookById (handbook, id) {
      return this[handbook].find(item => item.id === id)
    },
    substitutionPlan (val) {
      if (val.length) {
        const job = this.findItemHandbookById('projectPTOJobs', val[0].id)
        this.setItemAfterUpdateJob({
          plan: job.price,
          planVolume: job.work_scope,
          measureUnit: this.findItemHandbookById('measureUnitList', job.measure_unit_id)
        })
      } else {
        this.clearItemAfterUpdateJob()
      }
    },
    async calculateFot (val) {
      this.formData.labor_costs = val
      let findDate = currentDate()
      if (this.formData.start_date) findDate = this.formData.start_date

      await this.GETCostPersonHourList({ date: findDate })
      if (this.сostPersonHourList.length) {
        const currentPrice = this.сostPersonHourList[0].price
        this.formData.fot = currentPrice * val
      } else this.formData.fot = null
    },
    changeStartDate (val) {
      this.formData.start_date = val
      this.calculateFot(this.formData.labor_costs)
    }
  },
  computed: {
    currentDate () {
      let date = new Date(currentDate())
      date = formatDateForServer(date)
      return date
    },
    ...mapState('handbook/pto', {
      measureUnitList: 'measureUnitList',
      projectPTOJobs: 'projectPTOJobList',
      сostPersonHourList: 'сostPersonHourList'

    })
  },
  mixins: [
    MIXIN_FORM_PTO,
    mixinPtoProjectPTOJobSelect
  ]
}
</script>
